import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useSetRecoilState } from "recoil";
import styled from "styled-components";
import {
  reservedPayDropdown,
  reservedPaySearch,
} from "../../../pages/Pay/ReservedPay";
import { tempAccountTabState } from "../../pages/Manage/TempAccount/TempAccountTab";
import { chatTabState } from "../../pages/Party/ChatInfo/ChatTab";
import { partyInviteTabState } from "../../pages/Party/PartyInvite/PartyInviteTab";
import {
  payFailDropdownState,
  payFailSearchState,
} from "../../pages/Pay/PayFail/CalculatePayFail";
import { payFailTabState } from "../../pages/Pay/PayFail/PayFailTab";
import {
  payInfoDropdownState,
  payInfoSearchState,
} from "../../pages/Pay/PayInfo/PayInfoFilter";

interface MenuItemProps {
  onClickEvent: () => void;
  isClicked: boolean;
  title: string;
  child: string[];
}

interface IsClickedProps {
  isClicked: boolean;
}

interface MenuChildProps extends IsClickedProps {
  childLength: number;
}

interface SMenuChildItem {
  isActivate: boolean;
}

export default function MenuItem({
  onClickEvent,
  isClicked,
  title,
  child,
}: MenuItemProps) {
  const location = useLocation();
  const setTab = useSetRecoilState(chatTabState);
  const setPayFailTabState = useSetRecoilState(payFailTabState);
  const setPartyInviteTabState = useSetRecoilState(partyInviteTabState);
  const setPayInfoDropdown = useSetRecoilState(payInfoDropdownState);
  const setPayInfoSearch = useSetRecoilState(payInfoSearchState);
  const setPayReservedDropdown = useSetRecoilState(reservedPayDropdown);
  const setPayReservedSearch = useSetRecoilState(reservedPaySearch);
  const setPayFailDropdown = useSetRecoilState(payFailDropdownState);
  const setPayFailSearch = useSetRecoilState(payFailSearchState);
  const setTempAccount = useSetRecoilState(tempAccountTabState);

  const childClickEvent = (childName: string) => {
    let pathname = "";

    switch (childName) {
      case "회원 정보":
        pathname = "users/info";
        break;

      case "코멘트":
        pathname = "users/comment";
        break;

      case "블랙리스트":
        pathname = "users/black-list";
        break;

      case "탈퇴 회원 정보":
        pathname = "users/exit-users-info";
        break;

      case "파티 정보":
        pathname = "party/info";
        break;

      case "매칭 현황":
        pathname = "party/matching";
        break;

      case "채팅":
        pathname = "party/chat";
        break;

      case "파티 초대 관리":
        pathname = "party/invite";
        break;

      case "구. 유플러스 결합":
        pathname = "party/old-uplus";
        break;

      case "유플러스 결합":
        pathname = "party/uplus";
        break;

      case "매치메이킹 파티":
        pathname = "party/match-making";
        break;

      case "뉴_매치메이킹 파티":
        pathname = "party/N_match-making";
        break;
      case "링고키즈":
        pathname = "party/lingokids";
        break;

      case "개인 연간 파티":
        pathname = "party/youtube";
        break;
      case "유튜브 개인":
        pathname = "party/youtube-personal";
        break;
      case "유튜브 프리미엄_해외":
        pathname = "party/youtube_world";
        break;

      case "결제/적립/인출 정보":
        pathname = "pay/info";
        break;

      case "예약 결제":
        pathname = "pay/reserve";
        break;

      case "실패":
        pathname = "pay/fail";
        break;

      case "쿠폰 관리":
        pathname = "benefit/coupon";
        break;

      case "포인트 관리":
        pathname = "benefit/point";
        break;

      case "스탬프 관리":
        pathname = "benefit/stamp";
        break;
      case "링크아이 사전예약":
        pathname = "benefit/prereg_linkai";
        break;
      case "🔥 타임 이벤트":
        pathname = "benefit/timeEvent";
        break;

      case "알림톡 관리":
        pathname = "message/alimtalk";
        break;

      case "LMS 관리":
        pathname = "message/lms";
        break;

      case "알림톡 발송 실패":
        pathname = "message/alimtalk/fail";
        break;

      case "앱 푸시 관리":
        pathname = "message/app-push";
        break;

      case "유효성 체크":
        pathname = "linkid-manage/valid-check";
        break;

      case "임시 계정 관리":
        pathname = "linkid-manage/temp-account";
        break;

      case "일몰 관리":
        pathname = "linkid-manage/sunset";
        break;

      case "자주 묻는 질문 관리":
        pathname = "linkid-manage/faq";
        break;

      case "팝업 관리":
        pathname = "linkid-manage/popup";
        break;

      case "상태 관리":
        pathname = "linkid-manage/status";
        break;

      case "공지사항":
        pathname = "linkid-manage/notice";
        break;

      case "약관 관리":
        pathname = "linkid-manage/terms";
        break;

      case "고객제안":
        pathname = "linkid-manage/suggest";
        break;

      case "파티 탈퇴/해산 사유 확인":
        pathname = "linkid-manage/party-exit-reason";
        break;

      case "관리자 계정 관리":
        pathname = "manage/auth";
        break;

      case "운영 로그":
        pathname = "manage/log";
        break;

      default:
        break;
    }

    return pathname;
  };

  const childItemActivate = (childName: string) => {
    if (
      childName === "회원 정보" &&
      location?.pathname?.includes("/users/info")
    ) {
      return true;
    } else if (
      childName === "코멘트" &&
      location?.pathname === "/users/comment"
    ) {
      return true;
    } else if (
      childName === "블랙리스트" &&
      location?.pathname === "/users/black-list"
    ) {
      return true;
    } else if (
      childName === "탈퇴 회원 정보" &&
      location?.pathname === "/users/exit-users-info"
    ) {
      return true;
    } else if (
      childName === "파티 정보" &&
      location?.pathname?.includes("/party/info")
    ) {
      return true;
    } else if (
      childName === "매칭 현황" &&
      location?.pathname === "/party/matching"
    ) {
      return true;
    } else if (childName === "채팅" && location?.pathname === "/party/chat") {
      return true;
    } else if (
      childName === "파티 초대 관리" &&
      location?.pathname === "/party/invite"
    ) {
      return true;
    } else if (
      childName === "구. 유플러스 결합" &&
      location?.pathname === "/party/old-uplus"
    ) {
      return true;
    } else if (
      childName === "유플러스 결합" &&
      location?.pathname === "/party/uplus"
    ) {
      return true;
    } else if (
      childName === "매치메이킹 파티" &&
      location?.pathname === "/party/match-making"
    ) {
      return true;
    } else if (
      childName === "뉴_매치메이킹 파티" &&
      location?.pathname === "/party/N_match-making"
    ) {
      return true;
    } else if (
      childName === "링고키즈" &&
      location?.pathname === "/party/lingokids"
    ) {
      return true;
    } else if (
      childName === "개인 연간 파티" &&
      location?.pathname === "/party/youtube"
    ) {
      return true;
    } else if (
      childName === "유튜브 개인" &&
      location?.pathname === "/party/youtube-personal"
    ) {
      return true;
    } else if (
      childName === "유튜브 프리미엄_해외" &&
      location?.pathname === "/party/youtube_world"
    ) {
      return true;
    } else if (
      childName === "결제/적립/인출 정보" &&
      location?.pathname === "/pay/info"
    ) {
      return true;
    } else if (
      childName === "예약 결제" &&
      location?.pathname === "/pay/reserve"
    ) {
      return true;
    } else if (childName === "실패" && location?.pathname === "/pay/fail") {
      return true;
    } else if (
      childName === "쿠폰 관리" &&
      location?.pathname === "/benefit/coupon"
    ) {
      return true;
    } else if (
      childName === "포인트 관리" &&
      location?.pathname === "/benefit/point"
    ) {
      return true;
    } else if (
      childName === "스탬프 관리" &&
      location?.pathname === "/benefit/stamp"
    ) {
      return true;
    } else if (
      childName === "링크아이 사전예약" &&
      location?.pathname === "/benefit/prereg_linkai"
    ) {
      return true;
    } else if (
      childName === "🔥 타임 이벤트" &&
      location?.pathname === "/benefit/timeEvent"
    ) {
      return true;
    } else if (
      childName === "알림톡 관리" &&
      location?.pathname === "/message/alimtalk"
    ) {
      return true;
    } else if (
      childName === "LMS 관리" &&
      location?.pathname === "/message/lms"
    ) {
      return true;
    } else if (
      childName === "알림톡 발송 실패" &&
      location?.pathname === "/message/alimtalk/fail"
    ) {
      return true;
    } else if (
      childName === "앱 푸시 관리" &&
      location?.pathname === "/message/app-push"
    ) {
      return true;
    } else if (
      childName === "관리자 계정 관리" &&
      location?.pathname === "/manage/auth"
    ) {
      return true;
    } else if (
      childName === "운영 로그" &&
      location?.pathname === "/manage/log"
    ) {
      return true;
    } else if (
      childName === "유효성 체크" &&
      location?.pathname === "/linkid-manage/valid-check"
    ) {
      return true;
    } else if (
      childName === "임시 계정 관리" &&
      location?.pathname === "/linkid-manage/temp-account"
    ) {
      return true;
    } else if (
      childName === "일몰 관리" &&
      location?.pathname?.includes("/linkid-manage/sunset")
    ) {
      return true;
    } else if (
      childName === "자주 묻는 질문 관리" &&
      location?.pathname?.includes("linkid-manage/faq")
    ) {
      return true;
    } else if (
      childName === "팝업 관리" &&
      location?.pathname?.includes("linkid-manage/popup")
    ) {
      return true;
    } else if (
      childName === "상태 관리" &&
      location?.pathname?.includes("/linkid-manage/status")
    ) {
      return true;
    } else if (
      childName === "공지사항" &&
      location?.pathname?.includes("/linkid-manage/notice")
    ) {
      return true;
    } else if (
      childName === "약관 관리" &&
      location?.pathname?.includes("/linkid-manage/terms")
    ) {
      return true;
    } else if (
      childName === "고객제안" &&
      location?.pathname?.includes("linkid-manage/suggest")
    ) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <MenuItemContainer>
      <MenuTitle
        onClick={() => {
          onClickEvent();
        }}
      >
        <MenuTitleText
          isActivate={
            (title === "대시보드" &&
              location?.pathname?.includes("dashboard")) ||
            (title === "회원 관리" && location?.pathname?.includes("users")) ||
            (title === "파티 관리" && location?.pathname?.includes("party")) ||
            (title === "NEW 유저 로그" &&
              location?.pathname?.includes("new-userlog")) ||
            (title === "유저 로그" &&
              location?.pathname?.includes("/userlog")) ||
            (title === "정산 관리" && location?.pathname?.includes("pay")) ||
            (title === "혜택 관리" &&
              location?.pathname?.includes("benefit")) ||
            (title === "메세지 관리" &&
              location?.pathname?.includes("message")) ||
            (title === "링키드 관리" &&
              location?.pathname?.includes("linkid-manage")) ||
            (title === "관리자" && location?.pathname?.includes("/manage/"))
          }
        >
          {title}
        </MenuTitleText>

        {child?.length > 0 && (
          <MenuChevron isClicked={isClicked} className="material-icons">
            chevron_right
          </MenuChevron>
        )}
      </MenuTitle>

      <MenuChild childLength={child?.length} isClicked={isClicked}>
        {child?.map((c, index) => {
          return (
            <Link
              to={childClickEvent(c)}
              key={index}
              onClick={() => {
                if (c === "채팅") {
                  setTab(0);
                } else if (c === "실패") {
                  setPayFailTabState(0);
                  setPayFailDropdown({
                    value: "",
                    label: "선택",
                  });
                  setPayFailSearch("");
                } else if (c === "링키드 메일 관리") {
                  setPartyInviteTabState(0);
                } else if (c === "결제/적립/인출 정보") {
                  setPayInfoDropdown({
                    value: "",
                    label: "선택",
                  });
                  setPayInfoSearch("");
                } else if (c === "예약 결제") {
                  setPayReservedDropdown({
                    value: "",
                    label: "선택",
                  });
                  setPayReservedSearch("");
                } else if (c === "임시 계정 관리") {
                  setTempAccount(0);
                }
              }}
            >
              <MenuChildItem isActivate={childItemActivate(c)}>
                {c}
              </MenuChildItem>
            </Link>
          );
        })}
      </MenuChild>
    </MenuItemContainer>
  );
}

const MenuItemContainer = styled.div`
  width: 100%;

  &:not(:last-child) {
    margin-bottom: 4px;
  }
`;

const MenuTitle = styled.div`
  cursor: pointer;
  width: 100%;
  height: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px 0 18px;
`;

const MenuTitleText = styled.span<SMenuChildItem>`
  font-size: 16px;
  font-weight: bold;
  line-height: 24px;
  text-align: left;
  color: ${({ isActivate, theme }) =>
    isActivate ? theme.color.white : "#d3d3d3"};
`;

const MenuChevron = styled.span<IsClickedProps>`
  width: 18px;
  height: 18px;
  transform: ${({ isClicked }) => (isClicked ? "rotate(90deg)" : "none")};
  transition: transform 0.1s ease-out;
  color: #d3d3d3;
  display: flex;
  align-items: center;
  font-size: 16px;
`;

const MenuChild = styled.ul<MenuChildProps>`
  width: 100%;
  height: ${({ childLength, isClicked }) =>
    isClicked ? `calc(40px*${childLength})` : "0px"};
  overflow: hidden;
  transition: height 0.2s ease-out;
`;

const MenuChildItem = styled.li<SMenuChildItem>`
  cursor: pointer;
  display: flex;
  align-items: center;
  padding-left: 34px;
  width: 100%;
  height: 40px;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  text-align: left;
  color: ${({ isActivate }) => (isActivate ? "#0ddddd" : "#d3d3d3")};

  &:hover {
    color: #0ddddd;
  }
`;
